import HTTPResponseEntity    from "@/js/Shared/Services/HTTP/Entities/HTTPResponseEntity";
import BroadcastEventManager from "./Managers/BroadcastEventManager";
import {ref}                 from 'vue';

export {EventUpload as default};

/**
* Event Upload
*
* @author      rsimoes <ruben-r-simoes@telecom.pt>
* @copyright   Copyright (C) Sapo. All rights reserved.
* @license     Private
* @since       7.0.0
*/
class EventUpload {

  /**
   * Upload id
   *
   * @public
   *
   * @since 7.0.0
   *
   * @type {String}
   */
  id;

  /**
   * Upload type
   *
   * @public
   *
   * @since 7.0.0
   *
   * @type {String}
   */
  type;

  /**
   * Upload target
   *
   * @public
   *
   * @since 7.0.0
   *
   * @type {String}
   */
  target;

  /**
   * Upload target id
   *
   * @public
   *
   * @since 7.0.0
   *
   * @type {String}
   */
  target_id;

  /**
   * Total upload progress
   *
   * @public
   *
   * @since 7.0.0
   *
   * @type {Number}
   */
  progress_total = 0;

  /**
   * Percentage upload progress
   *
   * Until we figure out how to make vue update the template when this value changes
   *
   * @public
   *
   * @since 7.0.0
   *
   * @type {Number}
   */
  progress_percentage = ref(0);

  /**
   * Stores all files
   *
   * @public
   *
   * @since 7.0.0
   *
   * @type {File}
   */
  file;

  /**
   * Upload XML HTTP Request
   *
   * @public
   *
   * @since 7.0.0
   *
   * @type {XMLHttpRequest}
   */
  xhr = new XMLHttpRequest();

  /**
   * Event Broadcaster
   *
   * @public
   *
   * @since 7.0.0
   *
   * @type {BroadcastEventManager}
   */
  broadcaster = new BroadcastEventManager();

  /**
   * Constructor
   *
   * Updates the event progress
   *
   * @since 7.0.0
   *
   * @return {void}
   */
  constructor() {
    let event = this;

    this.xhr.upload.onprogress = (ev) => {
      event.progress_total            = ev.loaded;
      event.progress_percentage.value = (ev.loaded * 100) / ev.total;

      this.broadcaster.broadcast('upload-progress', event);
    };
  }

  /**
   * Sets the event as finished
   *
   * Broadcasts an upload-finished message
   *
   * @since 7.0.0
   *
   * @param {HTTPResponseEntity} response http response
   *
   * @return {void}
   */
  setFinished(response) {
    this.broadcaster.broadcast('upload-finished', response);
  }

    /**
   * Returns a size String representation
   *
   * @public
   *
   * @since 7.0.0
   *
   * @type {String}
   */
    get size_text () {
      const k     = 1024;
      const dm    = 2;
      const sizes = ['Bytes', 'Kb', 'Mb', 'Gb', 'Tb', 'Pb', 'Eb', 'Zb', 'Yb'];

      const i = Math.floor(Math.log(this.file.size) / Math.log(k));

      return `${parseFloat((this.file.size / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`;
    }
}